import { Injectable } from '@angular/core';
import { ICmsLink, ICmsLinkDirective } from '@icms/client/assets/link/icms-link.directive';
import { ICmsCoreIntegrationAbstractService } from './icms-core-integration-abstract.service';

@Injectable({ providedIn: 'root' })
export class ICmsCoreIntegrationLinkService<T extends ICmsLink = ICmsLink> extends ICmsCoreIntegrationAbstractService<
    ICmsLinkDirective<T>
> {}
